import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const StudentInterestForm = ({ onSubmit, formSubmitted }) => {
  const navigate = useNavigate();

  const [schoolEvents, setSchoolEvents] = useState('');
  const [localEvents, setLocalEvents] = useState('');

  // Load data from cookie if available
  useEffect(() => {
    const cookieData = Cookies.get('studentInterests');
    if (cookieData) {
      try {
        const parsed = JSON.parse(cookieData);
        setSchoolEvents(parsed.schoolEvents || '');
        setLocalEvents(parsed.localEvents || '');
      } catch (error) {
        console.error('Error parsing studentInterests cookie:', error);
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const interestData = {
      schoolEvents,
      localEvents,
    };

    // Save to localStorage and cookie
    localStorage.setItem('studentInterests', JSON.stringify(interestData));
    Cookies.set('studentInterests', JSON.stringify(interestData), { expires: 30 });

    // navigate('/pathwayselection');
    onSubmit(interestData);
  };

  return (
    <form className="container" onSubmit={handleSubmit}>
      <h5 className="fw-bold">Generate student interest or local event themes 
        <img src={require("../../assets/images/ThemeStormerIcons/game-console.png")} width="36" className="p-1"></img> 
        <img src={require("../../assets/images/ThemeStormerIcons/schedule.png")} width="36" className="p-1"></img> 
      </h5>
      <p>Optional: Complete the fields below to help Conjuror generate some theme ideas.</p>
      <p className="fst-italic text-success">If the fields are already filled with your previous inputs, feel free to edit them.</p>


      <div className="mb-3">
        <label className="form-label">
          What are some popular or timely activities or events at your school?
        </label>
        <input
          type="text"
          className="form-control"
          value={schoolEvents}
          onChange={(e) => setSchoolEvents(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">
          What are some popular or timely activities or events in your city or town?
        </label>
        <input
          type="text"
          className="form-control"
          value={localEvents}
          onChange={(e) => setLocalEvents(e.target.value)}
        />
      </div>

      <div className="text-center">
        <button type="submit" className="btn btn-primary" disabled={formSubmitted}>
          Give me theme ideas
        </button>
      </div>
    </form>
  );
}

export default StudentInterestForm;